import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'cm-loading-icon',
    templateUrl: './cm-loading-icon.component.html',
    styleUrls: ['./cm-loading-icon.component.scss'],
    standalone: false
})
export class CmLoadingIconComponent implements OnInit {
	@Input() size = 45;
	center: number;
	radius = 8;
	stroke = 2;
	hasInnerCirc = true;
	outerCirc = '6;22';
	innerCirc = '6;1;2;3;4;5;6';

	constructor() {}

	ngOnInit() {
		this.center = this.size / 2;
		if (this.size < 42) {
			this.stroke = 1;
			this.outerCirc = `1;${this.center - 2}`;
			this.innerCirc = (this.center / 2).toString();
			for (let i = 0; i < this.center / 2; i++) {
				this.innerCirc += ';' + i.toString();
			}
		}
		if (this.size < 18) this.hasInnerCirc = false;
	}
}
